module.exports = __webpack_public_path__ + "media/images/signatures/maria_mendieta-2a26817addab51626bf3d3b0ad3d5821.png";